/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-indent */
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FILTER_EXTRACT } from '../../../constants/types'
import * as reducks from '../../../reducks'
import routes from '../../../config/routes'
import history from '../../../lib/history'
import BoxIndicatorWithFilter from '../../commons/BoxIndicatorWithFilter/BoxIndicatorWithFilter'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import Flex from '../../commons/Flex/Flex'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Tag from '../../commons/Tag/Tag'
import Text from '../../commons/Text/Text'
import styles from './extractIndicatorsManagerial.module.scss'

const ExtractIndicatoresManagerial = () => {
  const dispatch = useDispatch()

  const [filterActive, setFilterActive] = useState({
    id: 0,
    title: 'Todos'
  })

  const { handleFilterManagements, handleCurrentExtract } =
    reducks.resources.extract.actions

  const { currentExtracts, extract } = useSelector(
    (state) => state.extractReducer
  )

  const { store: { nameFantasy, walletCode } = {} } = extract

  if (!walletCode) {
    history.goBack()
    return null
  }

  const handleFilter = (filter) => {
    setFilterActive(filter)
    dispatch(handleFilterManagements(filter?.id))
  }

  const breadcrumbs = [
    {
      id: 1,
      title: 'Carteira',
      path: routes.wallet.path
    },
    {
      id: 2,
      title: nameFantasy,
      path: routes.extract.generate(walletCode)
    },
    {
      id: 3,
      title: 'Indicadores'
    }
  ]

  return (
    <DefaultLayout>
      <Flex column flex="1">
        <Text color="gray" size="lg" variation="dark" bold>
          Indicadores gerenciais
        </Text>
        <Breadcrumb items={breadcrumbs} />
        <Flex column>
          <Flex alignItems="center" wrap="wrap">
            {FILTER_EXTRACT.map((item) => (
              <Tag
                white
                active={item.id === filterActive?.id}
                size="xs"
                key={item.id}
                text={item.title}
                id={item.id}
                onClick={handleFilter}
              />
            ))}
          </Flex>
          {currentExtracts?.length > 0 ? (
            <div className={styles.grid}>
              {currentExtracts.map((indicator) => (
                <BoxIndicatorWithFilter
                  margin="0px"
                  key={indicator.id}
                  indicator={indicator}
                  to={routes.extractDetailTwo.path}
                  onClick={(indication) => {
                    dispatch(handleCurrentExtract(indication))
                  }}
                />
              ))}
            </div>
          ) : (
            <Flex
              alignItems="center"
              justifyContent="center"
              margin="32px 0px 0px"
            >
              <Text size="xxs" color="gray" font="custom">
                Indicador não encontrado.
              </Text>
            </Flex>
          )}
        </Flex>
      </Flex>
    </DefaultLayout>
  )
}

export default ExtractIndicatoresManagerial
